import React, { FunctionComponent } from 'react';
import classnames from 'classnames';
import { useIntl, defineMessages } from 'react-intl';
import { Link } from 'dibs-elements/exports/Link';

// Style
import styles from './styles.scss';

import QuickViewIcon from 'dibs-icons/exports/InfoCircle';

type QuickViewButtonProps = {
    openQuickView?: () => void;
    showQuickViewIcon?: boolean;
    hideDivider?: boolean;
    isSbTile?: boolean;
};

const messages = defineMessages({
    label: {
        id: 'dibs-search-product-tile.QuickViewButton.label',
        defaultMessage: 'Show quick view information',
    },
});

export const QuickViewButton: FunctionComponent<QuickViewButtonProps> = ({
    openQuickView = () => {},
    showQuickViewIcon = true,
    hideDivider,
    isSbTile,
}) => {
    const intl = useIntl();
    if (!showQuickViewIcon) {
        return null;
    }
    return (
        <Link
            dataTn="quick-view-button"
            ariaLabel={intl.formatMessage(messages.label)}
            className={classnames(styles.link, {
                [styles.hideDivider]: hideDivider,
                [styles.isSbTile]: isSbTile,
            })}
            onClick={openQuickView}
        >
            <QuickViewIcon className={classnames({ [styles.isSbTile]: isSbTile })} />
        </Link>
    );
};
